/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import React from 'react';
import {
  Table,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
} from '@material-ui/core';
import _uniqueId from 'lodash/uniqueId';
import PropTypes from 'prop-types';

const SimpleDatagrid = (props) => {
  const { children, data, ids } = props;

  return (
    <>
      <Table style={{ width: '100%' }}>
        <TableHead>
          <TableRow>
            {children &&
              children.map(({ props }) => (
                <TableCell key={_uniqueId()}>
                  {props && props.label ? props.label : props.source}
                </TableCell>
              ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {ids &&
            ids.map((id) => (
              <TableRow key={_uniqueId()}>
                {React.Children.map(children, (child) => (
                  <TableCell key={_uniqueId()}>
                    {React.cloneElement(
                      child,
                      { record: data[id], key: _uniqueId() },
                      child.props.children ? child.props.children : null
                    )}
                  </TableCell>
                ))}
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </>
  );
};

SimpleDatagrid.propTypes = {
  data: PropTypes.object.isRequired,
  ids: PropTypes.array.isRequired,
};

export default SimpleDatagrid;
